var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 35.17 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n        stroke-width: 0px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 17.58,
    y1: 35,
    x2: 17.58,
    y2: 0.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0163df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18abfd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.58,0C7.87,0,0,7.87,0,17.58c0,8.67,6.27,15.87,14.52,17.32v-11.94h-4.47v-4.96h4.47v-3.78c0-4.3,2.63-6.68,6.66-6.68,1.93,0,3.94.34,3.94.34v4.23h-2.22c-2.19,0-2.87,1.32-2.87,2.68v3.22h4.89l-.78,4.96h-4.11v12.04c8.55-1.19,15.14-8.53,15.14-17.42C35.17,7.87,27.3,0,17.58,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.062bb1c25208e582761e29a0f3cde014.svg";
export { ForwardRef as ReactComponent };